import { render, staticRenderFns } from "./project_detail.vue?vue&type=template&id=e50fdf52&scoped=true&"
import script from "./project_detail.vue?vue&type=script&lang=js&"
export * from "./project_detail.vue?vue&type=script&lang=js&"
import style0 from "./project_detail.vue?vue&type=style&index=0&id=e50fdf52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50fdf52",
  null
  
)

export default component.exports